import { Action } from '@ngrx/store';

export const UPDATE_LANGUAGE = '[I18N] Update language';
export const UPDATE_CURRENCY = '[I18N] Update currency';
export const UPDATE_COUNTRY = '[I18N] Update country';
export const SET_DIRECT_SHIPPING_ELIGIBILITY = '[I18N] Set direct shipping eligibility';

export class UpdateLanguage implements Action {
  readonly type = UPDATE_LANGUAGE;
  constructor(public payload: any) {}
}

export class UpdateCurrency implements Action {
  readonly type = UPDATE_CURRENCY;
  constructor(public payload: any) {}
}

export class UpdateCountry implements Action {
  readonly type = UPDATE_COUNTRY;
  constructor(public payload: any) {}
}

export class SetDirectShippingEligibility implements Action {
  readonly type = SET_DIRECT_SHIPPING_ELIGIBILITY;
  constructor(public payload: boolean) {}
}

export type All = UpdateCurrency | UpdateLanguage | UpdateCountry | SetDirectShippingEligibility;
